import { makeAutoObservable } from 'mobx'
import { type PageLayoutStore } from 'shared/layout'
import type { IEntitiesStore } from 'entities/EntitiesExport'

export class KeywordPageStore {
  private _isKeywordsActionShown = false

  constructor(private _pageLayoutStore: PageLayoutStore, private _entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  get isKeywordsActionShown() {
    return this._isKeywordsActionShown
  }

  get pageLayoutStore() {
    return this._pageLayoutStore
  }

  get entities() {
    return this._entities
  }

  setIsKeywordsActionShown = (isKeywordsActionShown: boolean) => {
    this._isKeywordsActionShown = isKeywordsActionShown
  }
}
